<!-- TelcoTrack - Reset Password Page -->
<div class="min-h-screen flex items-center justify-center bg-neutral-50 py-12 px-4 sm:px-6 lg:px-8">
  <div class="max-w-md w-full space-y-8">
    <div class="text-center">
      <div class="mx-auto flex items-center justify-center">
        <img src="assets/images/ProTelco.png" alt="ProTelco Logo" class="h-auto w-auto max-h-24">
      </div>
      <h2 class="mt-6 text-3xl font-extrabold text-neutral-900">
        Nastavení nového hesla
      </h2>
      <p class="mt-2 text-sm text-neutral-600">
        Zadejte nové heslo pro váš účet
      </p>
    </div>

    <div *ngIf="!token" class="rounded-md bg-error-50 p-4">
      <div class="flex">
        <div class="flex-shrink-0">
          <svg class="h-5 w-5 text-error-500" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
          </svg>
        </div>
        <div class="ml-3">
          <h3 class="text-sm font-medium text-error-800">Chybí odkaz</h3>
          <div class="mt-2 text-sm text-error-700">{{ errorMessage }}</div>
          <div class="mt-3">
            <a routerLink="/auth/forgot-password" class="text-sm font-medium text-primary-600 hover:text-primary-500">
              Požádat znovu o reset hesla
            </a>
          </div>
        </div>
      </div>
    </div>

    <form *ngIf="token" class="mt-8 space-y-6" [formGroup]="resetForm" (ngSubmit)="onSubmit()">
      <div class="rounded-md bg-neutral-100 border border-neutral-200 p-3">
        <p class="text-sm font-medium text-neutral-800">Kritéria hesla</p>
        <p class="mt-1 text-sm text-neutral-600">{{ passwordPolicyHint }}</p>
      </div>

      <div class="space-y-4">
        <app-input
          type="password"
          label="Nové heslo"
          placeholder="Zadejte nové heslo"
          autocomplete="new-password"
          [required]="true"
          formControlName="password"
          [errorMessage]="getFieldError('password')">
        </app-input>

        <app-input
          type="password"
          label="Potvrdit heslo"
          placeholder="Potvrďte nové heslo"
          autocomplete="new-password"
          [required]="true"
          formControlName="confirmPassword"
          [errorMessage]="getFieldError('confirmPassword')">
        </app-input>
      </div>

      <div *ngIf="errorMessage" class="rounded-md bg-error-50 p-4">
        <div class="flex">
          <div class="flex-shrink-0">
            <svg class="h-5 w-5 text-error-500" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
            </svg>
          </div>
          <div class="ml-3">
            <h3 class="text-sm font-medium text-error-800">Chyba</h3>
            <div class="mt-2 text-sm text-error-700">{{ errorMessage }}</div>
          </div>
        </div>
      </div>

      <div *ngIf="successMessage" role="status" aria-live="polite" class="rounded-md bg-success-50 p-4">
        <div class="flex">
          <div class="flex-shrink-0">
            <svg class="h-5 w-5 text-success-500" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
            </svg>
          </div>
          <div class="ml-3">
            <h3 class="text-sm font-medium text-success-800">Úspěch!</h3>
            <div class="mt-2 text-sm text-success-700">{{ successMessage }}</div>
          </div>
        </div>
      </div>

      <div>
        <app-button
          type="submit"
          variant="primary"
          [fullWidth]="true"
          [loading]="isLoading"
          [disabled]="resetForm.invalid">
          {{ isLoading ? 'Ukládám...' : 'Nastavit heslo' }}
        </app-button>
      </div>

      <div class="text-center space-y-2">
        <p class="text-sm text-neutral-600">
          <a routerLink="/auth/login" class="text-primary-600 hover:text-primary-500 font-medium">
            Zpět na přihlášení
          </a>
        </p>
        <div>
          <a routerLink="/privacy" class="text-sm text-neutral-500 hover:text-primary-600">
            Zásady ochrany soukromí
          </a>
        </div>
      </div>
    </form>
  </div>
</div>
